<micro-lookup domain="smppserver" obj="smppServerPorts" url="/smppserver/smppServerPorts" [key]="smppServerPortId"></micro-lookup>
